import React, { useRef, useEffect } from "react";
import "./ProductCarousel.css";
import review1 from '../../../Reviews/review1.jpeg'
import review2 from '../../../Reviews/review2.jpeg'
import review3 from '../../../Reviews/reveiw3.png'
import review4 from '../../../Reviews/review4.png'
import review5 from '../../../Reviews/review5.png'
import review6 from '../../../Reviews/review6.png'

const products = [
    { image: review1 },
    { image: review2 },
    { image: review3 },
    { image: review4 },
    { image: review5 },
    { image: review6 },
  
];

const ProductCarousel = () => {
    const carouselRef = useRef(null);
    const intervalRef = useRef(null);

    // clone items (for infinite effect)
    const loopItems = [...products, ...products, ...products];

    useEffect(() => {
        const carousel = carouselRef.current;

        // Start from middle set
        const cardWidth = 100; // must match scroll step
        carousel.scrollLeft = products.length * cardWidth;

        intervalRef.current = setInterval(() => {
            carousel.scrollBy({
                left: cardWidth,
                behavior: "smooth",
            });

            const maxScroll = carousel.scrollWidth - carousel.clientWidth;

            // If reached end → reset to middle
            if (carousel.scrollLeft >= maxScroll - cardWidth) {
                setTimeout(() => {
                    carousel.scrollLeft = products.length * cardWidth;
                }, 400); // wait for smooth scroll to finish
            }
        }, 2000);

        return () => clearInterval(intervalRef.current);
    }, []);

    return (
        <div className="carousel-container" style={{ margin: '0 5px', padding: '1px' }}>
            <div className="carousel" ref={carouselRef}>
                {loopItems.map((product, index) => (
                    <div className="cards" key={index}>
                        <img src={product.image} alt={product.name} />

                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductCarousel;